// extracted by mini-css-extract-plugin
var _1 = "3px";
export { _1 as "commentThreadCompactAvatarPadding" }
